import React, { Component } from 'react';
import { dot } from "./styles/pins";

export default class NodeInputListItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hover: false
		}
	}

	onMouseUp(e) {
		e.stopPropagation();
  		e.preventDefault();

		this.props.onMouseUp(this.props.index);
	}

  onMouseOver() {
		this.setState({hover: true});
	}

	onMouseOut() {
    this.setState({hover: false});
  }

	noop(e) {
		e.stopPropagation();
  		e.preventDefault();
	}

	render() {
		// let {name} = this.props.item;
		let {hover} = this.state;

		return (
			<li>
				{/*eslint-disable-next-line*/}
				<a onClick={(e) => this.noop(e)} onMouseUp={(e) => this.onMouseUp(e)} href="#">
					<i className={hover ? 'fa fa-circle-o hover' : 'fa fa-circle-o'}
						 onMouseOver={() => {this.onMouseOver()}}
						 onMouseOut={() => {this.onMouseOut()}}
					/>
					<span style={dot}/>
{/*					{name}*/}
				</a>
			</li>
		);
	}
}
